import { CountryEntity } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { Stack, Typography } from 'libs/ui';
import { AddressFields, Section } from 'modules/client/common/components';
import { DocumentsTableFeature } from 'modules/client/common/feature';

import { FormContent as PlaceOfBirthFormContent } from '../PlaceOfBirthSection/FormContent';

interface Props {
  countriesLoading?: boolean;
  countries: CountryEntity[];
}

export const PlaceOfBirthAndResidentialAddressSection = ({
  countriesLoading,
  countries,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="placeOfBirthAndResidentialAddressSection"
      title={t('client.client.placeOfBirthAndResidentialAddress.title')}
    >
      <Stack spacing={24}>
        <Stack spacing={12}>
          <Typography variant="bodyBold">
            {t('client.client.placeOfBirth.title')}
          </Typography>
          <PlaceOfBirthFormContent
            countries={countries}
            countriesLoading={countriesLoading}
          />

          <Typography variant="bodyBold">
            {t('client.client.residentialAddress.title')}
          </Typography>
          <AddressFields
            countries={countries}
            countriesLoading={countriesLoading}
            variant="residentialAddress"
          />
        </Stack>

        <DocumentsTableFeature name="residentialAddress.proofOfResidenceFiles" />
      </Stack>
    </Section>
  );
};
